<template>
  <div v-if="singleMemo && singleDisposition">
    <v-list-item two-line v-if="myTask">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-list-item-avatar v-on="on" v-bind="attrs">
            <img
              :src="myTask.avatar_path"
              alt="delegate_by"
              v-if="myTask && myTask.creator"
            />
          </v-list-item-avatar>
        </template>
        <span>{{ myTask ? myTask.creator : "Atasan" }}</span>
      </v-tooltip>
      <v-list-item-content>
        <v-list-item-title class="headline"
          >{{
            singleMemo && singleMemo.memo
              ? $t("text.memo-title") + ": " + singleMemo.memo.hal
              : $t("text.dispositions-comment-is-empty")
          }}
        </v-list-item-title>
        <v-list-item-subtitle>
          <h4>
            <v-icon class="att-icon" color="warning" dark>
              {{ urgencyIcon(myTask.urgensi) }}
            </v-icon>
            {{ $t(urgencyLevel(myTask.urgensi)) }}
          </h4>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-spacer v-if="!$vuetify.breakpoint.smAndDown"></v-spacer>

      <v-tooltip bottom v-if="!$vuetify.breakpoint.smAndDown">
        <template v-slot:activator="{ on, attrs }">
          <span v-on="on" v-bind="attrs" class="text-right">
            {{ myTask ? $date(myTask.created_at).format("DD MMM YYYY") : "" }}
            <br />
            {{ myTask ? $date(myTask.created_at).format("HH:mm WIB") : "" }}
          </span>
        </template>
        <span>{{
          myTask
            ? $t("tooltip.received-approximately") +
              " " +
              $date(myTask.created_at).fromNow()
            : ""
        }}</span>
      </v-tooltip>
    </v-list-item>
    <v-card-text class="pt-2">
      <v-row>
        <v-col cols="12" md="6" sm="12" class="mt-sm-4">
          <h4
            v-if="$vuetify.breakpoint.smAndDown"
            class="align-center d-flex justify-end"
          >
            <v-icon class="mr-2">{{ iconTime }}</v-icon>
            <span>{{
              myTask
                ? $date(myTask.created_at).format("DD MMM YYYY HH:m") + " WIB"
                : ""
            }}</span>
          </h4>
          <p class="mt-4 mt-md-0 mb-2">
            {{ $t("text.disposition-direct-upline-comment") + ": "
            }}<strong>{{ myTask.comment }}</strong>
          </p>
          <h3
            class="text--bold mt-6 mb-4 mt-md-4"
            v-html="$t('label.disposition-recipients')"
          ></h3>
          <v-row>
            <v-col
              cols="12"
              md="6"
              sm="12"
              v-for="item in myTask.recipients"
              :key="item.nik"
            >
              <v-list-item
                three-line
                class="diposition__recipient-list"
                @click="showCompleteFeedback(null,item.feedback)"
              >
                <v-list-item-avatar>
                  <img v-bind:src="item.avatar_path" v-bind:alt="item.nik" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle
                    >{{ item.nama ? item.nama : "Nama Penerima Disposisi" }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="font-size-smaller"
                    >{{
                      item.readed_at
                        ? $t("text.readed-at") +
                          " " +
                          $date(item.readed_at).format("DD MMM YYYY HH:m") +
                          " WIB"
                        : $t("text.unread")
                    }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{
                      item.feedback
                        ? $t("text.feedback") + ": " + item.feedback
                        : $t("text.no-feedback")
                    }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <div></div>
          <h3
            class="mt-6 text--bold"
            v-if="singleMemo && parseInt(singleMemo.memo.is_izin_prinsip) === 1"
          >
            {{ $t("text.permit-disposition-detail") }}
          </h3>
          <h3 class="mt-6 text--bold" v-if="myTask.parents && myTask.parents.length > 0">
            {{ $t("text.early-disposition-detail") }}
          </h3>

          <v-col
            cols="12"
            md="12"
            sm="12"
            v-for="item in recipients"
            :key="item.nik"
            class="pa-0"
          >
            <v-list-item three-line class="permit__recipient-list" v-if="singleMemo && parseInt(singleMemo.memo.is_izin_prinsip) === 1">
              <v-list-item-avatar>
                <img v-bind:src="item.avatar_path" v-bind:alt="item.nik" />
              </v-list-item-avatar>
              <v-list-item-content>
                <span
                  class="approval__icon"
                  v-if="parseInt(item.is_approved) === 1"
                  >👍🏻</span
                >
                <span
                  class="approval__icon"
                  v-else-if="parseInt(item.is_approved) === 0"
                  >✋🏻</span
                >
                <span class="approval__icon" v-else></span>
                <v-list-item-subtitle
                  >{{ item.nama ? item.nama : "Nama Penerima" }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="font-size-smaller"
                  >{{
                    item.readed_at
                      ? $t("text.readed-at") +
                        " " +
                        $date(item.readed_at).format("DD MMM YYYY HH:m") +
                        " WIB"
                      : $t("text.unread")
                  }}
                </v-list-item-subtitle>
                <v-list-item-subtitle
                @click="showCompleteFeedback($t('msgbox.permit-comment'), item.comment)"
                >
                  {{
                    item.comment
                      ? item.comment
                      : "[" + $t("text.no-answer-yet") + "]"
                  }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-card-text class="mt-4">
            <v-row justify="center">
              <v-expansion-panels accordion>
                <v-expansion-panel
                  v-for="item in myTask.parents"
                  :key="item.id_hash"
                >
                  <v-expansion-panel-header>{{
                    item.creator
                  }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      class="d-inline-flex"
                      v-if="item.messages && item.messages.length > 0"
                    >
                      <p class="mr-2">
                        {{ $t("text.disposition-messages") }}:&nbsp;
                      </p>
                      <v-chip
                        class="mr-1 font-size-default"
                        small
                        v-for="(message, i) in item.messages"
                        :key="i"
                        >{{ message }}</v-chip
                      >
                    </div>
                    <p>
                      {{ $t("text.comment") + ": " + item.comment }}
                    </p>
                    <v-list-item
                      two-line
                      v-for="recipient in item.recipients"
                      :key="recipient.nik"
                    >
                      <v-list-item-avatar>
                        <img
                          v-bind:src="recipient.avatar_path"
                          v-bind:alt="recipient.nik"
                        />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{
                            recipient.nama
                              ? recipient.nama
                              : "Nama Penerima Disposisi"
                          }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-size-smaller"
                          >{{
                            recipient.readed_at
                              ? $t("text.readed-at") +
                                " " +
                                $date(recipient.readed_at).format(
                                  "DD MMM YYYY HH:m"
                                ) +
                                " WIB"
                              : $t("text.unread")
                          }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </v-card-text>
        </v-col>
        <v-col
          cols="12"
          md="6"
          sm="12"
          class="mt-sm-4"
          :class="`${
            !$vuetify.breakpoint.smAndDown ? 'tracking__border-left' : ''
          }`"
        >
          <h3
            class="mt-4 mt-md-0 mb-2 text--bold"
            v-html="$t('text.disposition-tracking')"
          ></h3>
          <p
            v-html="$t('text.the-track-of-memo-disposition-process')"
            class="mb-3"
          ></p>
          <tracking-disposition></tracking-disposition>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>
<script>
import { mapState } from "vuex";
import TrackingDisposition from "@/components/commonComponents/detailComponents/TrackingDisposition.vue";
import {
  mdiSpeedometerSlow,
  mdiSpeedometerMedium,
  mdiSpeedometer,
  mdiCogTransfer,
  mdiCheckBold,
  mdiCheck,
  mdiClockOutline,
} from "@mdi/js";

export default {
  name: "memo-view-detail",
  components: {
    TrackingDisposition,
  },
  data: () => ({
    iconSlow: mdiSpeedometerSlow,
    iconMedium: mdiSpeedometerMedium,
    iconFast: mdiSpeedometer,
    iconDirect: mdiCogTransfer,
    iconCheck: mdiCheckBold,
    iconTime: mdiClockOutline,
  }),
  computed: {
    ...mapState("disposition", ["singleDisposition", "singleMemo"]),
    ...mapState("user", ["currentUser"]),
    myTask() {
      if (!this.singleDisposition) return [];
      return this.singleDisposition;
    },
    recipients() {
      if (!this.singleMemo) return [];
      return this.singleMemo.penerima;
    },
  },
  methods: {
    urgencyIcon(val) {
      let intVal = parseInt(val);
      let result = this.iconMedium;

      switch (intVal) {
        case 1:
          result = this.iconDirect;
          break;
        case 2:
          result = this.iconSlow;
          break;
        case 3:
          result = this.iconMedium;
          break;
        case 4:
          result = this.iconFast;
          break;
        default:
          result = this.iconMedium;
          break;
      }
      return result;
    },
    urgencyLevel(val) {
      let intVal = parseInt(val);

      let result = "tooltip.disposition-urgency-direct";
      switch (intVal) {
        case 1:
          result = "tooltip.disposition-urgency-direct";
          break;
        case 2:
          result = "tooltip.disposition-urgency-normal";
          break;
        case 3:
          result = "tooltip.disposition-urgency-urgent";
          break;
        case 4:
          result = "tooltip.disposition-urgency-very-urgent";
          break;
        default:
          result = "tooltip.disposition-urgency-direct";
          break;
      }
      return result;
    },
    showCompleteFeedback(title, val) {
      if (!val) return;
      this.$dialog.info({
        text: val,
        title: title ? title : this.$t("msgbox.feedback-detail"),
        persistent: true,
        actions: [
          {
            text: this.$t("button.ok"),
            color: "success",
            key: false,
            icon: mdiCheck,
          },
        ],
      });
    },
  },
};
</script>